module.exports = __webpack_public_path__ + "static/favicon-39fc4a3faed2a33a3dee054349d1b83a.png";